<div class="basic-view-container" onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="name">
      <div class="mat-body-1 property-header">Queue name</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_NAME">{{ queue.queueName }}</div>
    </section>
    <section class="sip-address">
      <div class="mat-body-1 property-header">Queue SIP address</div>
      <div>{{ queue.appAddress }}</div>
    </section>
    <section class="extensions">
      <div class="mat-body-1 property-header">Queue extensions</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_QUEUE_EXTENSIONS">
        {{ queue.queueExtensions.length > 0 ? queue.queueExtensions : "None" }}
      </div>
    </section>
  </div>
  <div class="second-column">
    <section class="login-sip-address">
      <div class="mat-body-1 property-header">Login SIP address</div>
      <div>
        {{ queue.loginSipAddress + queue.appAddress.substring(queue.appAddress.indexOf("@")) }}
      </div>
    </section>
    <section class="login-pw">
      <div class="mat-body-1 property-header">Login password</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_LOGIN_PASS">
        {{ queue.password }}
      </div>
    </section>
    <section class="login-extensions">
      <div class="mat-body-1 property-header">Login extensions</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_LOGIN_EXTENSIONS">
        {{ queue.loginExtensions.length > 0 ? queue.loginExtensions : "None" }}
      </div>
    </section>
  </div>
  <div class="third-column">
    <section class="max-callers">
      <div class="mat-body-1 property-header">Max callers in queue</div>
      <div>{{ queue.maxCaller }}</div>
    </section>
    <section class="max-agents">
      <div class="mat-body-1 property-header">Max agents</div>
      <div>{{ queue.maxAgent }}</div>
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    class="toggle-button"
    color="primary"
    (click)="togglePanel()"
    [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_EDIT_BUTTON"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
